module.exports = __webpack_public_path__ + "static/media/html-icon.6bd9b8bf.svg";